// src/reducers/ai_websocket_v2a.js
import {
  ERROR_WEBSOCKET,
  CONNECT_WEBSOCKET_V2,
  MESSAGE_WEBSOCKET,
  DISCONNECT_WEBSOCKET_V2,
  CLEAR_CHAT_MESSAGES,
  CLEAR_ALL,
} from "../constants/actions";

const initialState = {
  isConnected: false,
  isConnecting: false,
  error: null,
  messages: {}, // Keep messages indexed by their IDs
};

const websocketReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONNECT_WEBSOCKET_V2:
      return {
        ...state,
        isConnected: true,
        isConnecting: false,
        error: null,
      };

    case DISCONNECT_WEBSOCKET_V2:
      return {
        ...state,
        isConnected: false,
        isConnecting: false,
        error: null,
      };

    case MESSAGE_WEBSOCKET: {
      const message = action.payload;

      if (!message?.id) return state;
      // Prefix IDs based on message source
      const messageId =
        message.from === "user" ? `usr-${message.id}` : `ast-${message.id}`;
      const existingMessage = state.messages[messageId];

      if (
        existingMessage &&
        message.from === "assistant" &&
        message.status === "streaming"
      ) {
        // Append to existing streaming message
        return {
          ...state,
          messages: {
            ...state.messages,
            [messageId]: {
              ...existingMessage,
              message: existingMessage.message + (message.message || ""),
            },
          },
        };
      }

      // Store new message if it has content
      if (message.message?.trim()) {
        return {
          ...state,
          messages: {
            ...state.messages,
            [messageId]: message,
          },
        };
      }

      return state;
    }

    case ERROR_WEBSOCKET:
      return {
        ...state,
        error: action.payload,
        isConnected: false,
        isConnecting: false,
      };

    case CLEAR_CHAT_MESSAGES:
      return {
        ...state,
        ...initialState,
      };

    case CLEAR_ALL:
      return initialState;

    default:
      return state;
  }
};

export default websocketReducer;
